export enum AlertType {
  insect = 'insect',
  weather = 'weather'
}
